/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { Acordo } from '../models/acordo';
import { AcordoPaginado } from '../models/acordo-paginado';
import { AcordoResponse } from '../models/acordo-response';

/**
 * e criado somente apos a finalizacao do processo de aprovacao de geracao do acordo, e criado a partir de uma proposta
 */
@Injectable({
  providedIn: 'root',
})
class AcordoService extends __BaseService {
  static readonly obterAcordoPorCodigoPath = '/acordos/{codigoAcordo}';
  static readonly obterAcordosPath = '/acordos';
  static readonly salvarAcordoPath = '/acordos';
  static readonly alterarAcordoPath = '/acordos';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Recupera os dados de uma proposta de acordo especifica
   * @param codigoAcordo Codigo identificador do acordo
   * @return Operacao realizada com sucesso
   */
  obterAcordoPorCodigoResponse(codigoAcordo: number): __Observable<__StrictHttpResponse<Acordo>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/acordos/${encodeURIComponent(String(codigoAcordo))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Acordo>;
      })
    );
  }
  /**
   * Recupera os dados de uma proposta de acordo especifica
   * @param codigoAcordo Codigo identificador do acordo
   * @return Operacao realizada com sucesso
   */
  obterAcordoPorCodigo(codigoAcordo: number): __Observable<Acordo> {
    return this.obterAcordoPorCodigoResponse(codigoAcordo).pipe(
      __map(_r => _r.body as Acordo)
    );
  }

  /**
   * Recupera uma listagem dos acordos com base nos parametros informados
   * @param params The `AcordoService.ObterAcordosParams` containing the following parameters:
   *
   * - `valorInicial`: Faixa de valor inicial na pesquisa
   *
   * - `valorFinal`: Faixa de valor final na pesquisa
   *
   * - `sucursal`: Sucursal
   *
   * - `sequenciaItemSinistro`: Numero do sinistro
   *
   * - `ramoSinistro`: Codigo do ramo do sinistro
   *
   * - `periodoInicial`: Data inicial da pesquisa
   *
   * - `periodoFinal`: Data final da pesquisa
   *
   * - `perfilAlcada`: Codigo do perfil aprovador de alcada
   *
   * - `perPage`: Quantidade registros por pagina
   *
   * - `page`: Pagina inicial
   *
   * - `orderType`: Ordenção por. Recebe o campo ao qual a consulta deverá ser ordenada
   *
   *    **ASC** ou **DESC**.
   *
   * - `orderBy`: Ordenção por. Recebe o campo ao qual a consulta deverá ser ordenada.
   *
   *   <table><tr><td><b>Campos ordenáveis</b></td></tr><tr><td>numero-acordo</td></tr><tr><td>nome-terceiro</td></tr><tr><td>situacao</td></tr><tr><td>dataAcordo</td></tr><tr><td>valorAcordo</td></tr></table>
   *
   * - `numeroSinistro`: Numero do sinistro
   *
   * - `numeroAcordo`: Numero do Acordo
   *
   * - `cpfCnpj`: Numero do CPF ou CNPJ do devedor
   *
   * - `codigoTipoProcedencia`: Codigo identificador do tipo de procedencia
   *
   * - `codigoTipoPessoa`: Identificador do tipo de documento do devedor, F - Fisica, J - Juridica
   *
   * - `codigoStatus`: Codigo do status do acordo
   *
   * - `codigoSinistroItau`: Codigo Sinistro ITAU
   *
   * - `codigoModalidade`: Codigo da Modalidade (Marca)
   *
   * - `codigoFormaPagamento`: Codigo identificador da forma de pagamento
   *
   * - `codigoEscritorio`: Codigo do escritorio
   *
   * - `anoSinistro`: Numero do sinistro
   *
   * @return Operacao realizada com sucesso
   */
  obterAcordosResponse(params: AcordoService.ObterAcordosParams): __Observable<__StrictHttpResponse<AcordoPaginado>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.valorInicial != null) __params = __params.set('valorInicial', params.valorInicial.toString());
    if (params.valorFinal != null) __params = __params.set('valorFinal', params.valorFinal.toString());
    if (params.sucursal != null) __params = __params.set('sucursal', params.sucursal.toString());
    if (params.sequenciaItemSinistro != null) __params = __params.set('sequenciaItemSinistro', params.sequenciaItemSinistro.toString());
    if (params.ramoSinistro != null) __params = __params.set('ramoSinistro', params.ramoSinistro.toString());
    if (params.periodoInicial != null) __params = __params.set('periodoInicial', params.periodoInicial.toString());
    if (params.periodoFinal != null) __params = __params.set('periodoFinal', params.periodoFinal.toString());
    if (params.perfilAlcada != null) __params = __params.set('perfilAlcada', params.perfilAlcada.toString());
    if (params.perPage != null) __params = __params.set('perPage', params.perPage.toString());
    if (params.page != null) __params = __params.set('page', params.page.toString());
    if (params.orderType != null) __params = __params.set('orderType', params.orderType.toString());
    if (params.orderBy != null) __params = __params.set('orderBy', params.orderBy.toString());
    if (params.numeroSinistro != null) __params = __params.set('numeroSinistro', params.numeroSinistro.toString());
    if (params.numeroAcordo != null) __params = __params.set('numeroAcordo', params.numeroAcordo.toString());
    if (params.cpfCnpj != null) __params = __params.set('cpfCnpj', params.cpfCnpj.toString());
    if (params.codigoTipoProcedencia != null) __params = __params.set('codigoTipoProcedencia', params.codigoTipoProcedencia.toString());
    if (params.codigoTipoPessoa != null) __params = __params.set('codigoTipoPessoa', params.codigoTipoPessoa.toString());
    if (params.codigoStatus != null) __params = __params.set('codigoStatus', params.codigoStatus.toString());
    if (params.codigoSinistroItau != null) __params = __params.set('codigoSinistroItau', params.codigoSinistroItau.toString());
    if (params.codigoModalidade != null) __params = __params.set('codigoModalidade', params.codigoModalidade.toString());
    if (params.codigoFormaPagamento != null) __params = __params.set('codigoFormaPagamento', params.codigoFormaPagamento.toString());
    if (params.codigoEscritorio != null) __params = __params.set('codigoEscritorio', params.codigoEscritorio.toString());
    if (params.anoSinistro != null) __params = __params.set('anoSinistro', params.anoSinistro.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/acordos`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AcordoPaginado>;
      })
    );
  }
  /**
   * Recupera uma listagem dos acordos com base nos parametros informados
   * @param params The `AcordoService.ObterAcordosParams` containing the following parameters:
   *
   * - `valorInicial`: Faixa de valor inicial na pesquisa
   *
   * - `valorFinal`: Faixa de valor final na pesquisa
   *
   * - `sucursal`: Sucursal
   *
   * - `sequenciaItemSinistro`: Numero do sinistro
   *
   * - `ramoSinistro`: Codigo do ramo do sinistro
   *
   * - `periodoInicial`: Data inicial da pesquisa
   *
   * - `periodoFinal`: Data final da pesquisa
   *
   * - `perfilAlcada`: Codigo do perfil aprovador de alcada
   *
   * - `perPage`: Quantidade registros por pagina
   *
   * - `page`: Pagina inicial
   *
   * - `orderType`: Ordenção por. Recebe o campo ao qual a consulta deverá ser ordenada
   *
   *    **ASC** ou **DESC**.
   *
   * - `orderBy`: Ordenção por. Recebe o campo ao qual a consulta deverá ser ordenada.
   *
   *   <table><tr><td><b>Campos ordenáveis</b></td></tr><tr><td>numero-acordo</td></tr><tr><td>nome-terceiro</td></tr><tr><td>situacao</td></tr><tr><td>dataAcordo</td></tr><tr><td>valorAcordo</td></tr></table>
   *
   * - `numeroSinistro`: Numero do sinistro
   *
   * - `numeroAcordo`: Numero do Acordo
   *
   * - `cpfCnpj`: Numero do CPF ou CNPJ do devedor
   *
   * - `codigoTipoProcedencia`: Codigo identificador do tipo de procedencia
   *
   * - `codigoTipoPessoa`: Identificador do tipo de documento do devedor, F - Fisica, J - Juridica
   *
   * - `codigoStatus`: Codigo do status do acordo
   *
   * - `codigoSinistroItau`: Codigo Sinistro ITAU
   *
   * - `codigoModalidade`: Codigo da Modalidade (Marca)
   *
   * - `codigoFormaPagamento`: Codigo identificador da forma de pagamento
   *
   * - `codigoEscritorio`: Codigo do escritorio
   *
   * - `anoSinistro`: Numero do sinistro
   *
   * @return Operacao realizada com sucesso
   */
  obterAcordos(params: AcordoService.ObterAcordosParams): __Observable<AcordoPaginado> {
    return this.obterAcordosResponse(params).pipe(
      __map(_r => _r.body as AcordoPaginado)
    );
  }

  /**
   * Cadastra um Acordo
   * @param acordo Objeto do acordo
   * @return Operacao realizada com sucesso
   */
  salvarAcordoResponse(acordo: Acordo): __Observable<__StrictHttpResponse<AcordoResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = acordo;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/acordos`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AcordoResponse>;
      })
    );
  }
  /**
   * Cadastra um Acordo
   * @param acordo Objeto do acordo
   * @return Operacao realizada com sucesso
   */
  salvarAcordo(acordo: Acordo): __Observable<AcordoResponse> {
    return this.salvarAcordoResponse(acordo).pipe(
      __map(_r => _r.body as AcordoResponse)
    );
  }

  /**
   * Altera os dados de um Acordo
   * @param acordo Objeto do acordo
   */
  alterarAcordoResponse(acordo: Acordo): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = acordo;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/acordos`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Altera os dados de um Acordo
   * @param acordo Objeto do acordo
   */
  alterarAcordo(acordo: Acordo): __Observable<null> {
    return this.alterarAcordoResponse(acordo).pipe(
      __map(_r => _r.body as null)
    );
  }
}

module AcordoService {

  /**
   * Parameters for obterAcordos
   */
  export interface ObterAcordosParams {

    /**
     * Faixa de valor inicial na pesquisa
     */
    valorInicial?: number;

    /**
     * Faixa de valor final na pesquisa
     */
    valorFinal?: number;

    /**
     * Sucursal
     */
    sucursal?: number;

    /**
     * Numero do sinistro
     */
    sequenciaItemSinistro?: number;

    /**
     * Codigo do ramo do sinistro
     */
    ramoSinistro?: number;

    /**
     * Data inicial da pesquisa
     */
    periodoInicial?: string;

    /**
     * Data final da pesquisa
     */
    periodoFinal?: string;

    /**
     * Codigo do perfil aprovador de alcada
     */
    perfilAlcada?: number;

    /**
     * Quantidade registros por pagina
     */
    perPage?: number;

    /**
     * Pagina inicial
     */
    page?: number;

    /**
     * Ordenção por. Recebe o campo ao qual a consulta deverá ser ordenada
     *
     *  **ASC** ou **DESC**.
     */
    orderType?: string;

    /**
     * Ordenção por. Recebe o campo ao qual a consulta deverá ser ordenada.
     *
     * <table><tr><td><b>Campos ordenáveis</b></td></tr><tr><td>numero-acordo</td></tr><tr><td>nome-terceiro</td></tr><tr><td>situacao</td></tr><tr><td>dataAcordo</td></tr><tr><td>valorAcordo</td></tr></table>
     */
    orderBy?: string;

    /**
     * Numero do sinistro
     */
    numeroSinistro?: number;

    /**
     * Numero do Acordo
     */
    numeroAcordo?: number;

    /**
     * Numero do CPF ou CNPJ do devedor
     */
    cpfCnpj?: string;

    /**
     * Codigo identificador do tipo de procedencia
     */
    codigoTipoProcedencia?: number;

    /**
     * Identificador do tipo de documento do devedor, F - Fisica, J - Juridica
     */
    codigoTipoPessoa?: string;

    /**
     * Codigo do status do acordo
     */
    codigoStatus?: number;

    /**
     * Codigo Sinistro ITAU
     */
    codigoSinistroItau?: string;

    /**
     * Codigo da Modalidade (Marca)
     */
    codigoModalidade?: number;

    /**
     * Codigo identificador da forma de pagamento
     */
    codigoFormaPagamento?: number;

    /**
     * Codigo do escritorio
     */
    codigoEscritorio?: number;

    /**
     * Numero do sinistro
     */
    anoSinistro?: number;
  }
}

export { AcordoService }
